(() => {
  if (window.MereldonMeasurements) return;

  const storageKey = 'mereldonMeasurementUnit';
  const measurementPattern = /\b(bust|waist|hip|hips|length|inseam|height|underbust|hem|shoulder|sleeve)\b/i;
  let currentUnit = 'cm';

  const readPreference = () => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return saved === 'in' ? 'in' : 'cm';
    } catch (error) {
      return 'cm';
    }
  };

  const savePreference = (unit) => {
    try {
      window.localStorage.setItem(storageKey, unit);
    } catch (error) {
      return;
    }
  };

  const measurementColumns = (table) => {
    const headers = Array.from(table.querySelectorAll('thead tr:first-child th'));
    return headers
      .map((header, index) => {
        if (!measurementPattern.test(header.textContent)) return -1;
        if (!header.dataset.mereldonCmLabel) {
          header.dataset.mereldonCmLabel = header.textContent.trim().replace(/\bin\)/i, 'cm)');
        }
        return index;
      })
      .filter((index) => index > -1);
  };

  const updateTable = (table, unit) => {
    const columns = measurementColumns(table);
    if (!columns.length) return;

    const headers = Array.from(table.querySelectorAll('thead tr:first-child th'));
    columns.forEach((index) => {
      const header = headers[index];
      if (!header) return;
      const base = header.dataset.mereldonCmLabel || header.textContent.trim();
      header.textContent = base.replace(/\bcm\)/i, unit === 'in' ? 'in)' : 'cm)');
    });

    table.querySelectorAll('tbody tr').forEach((row) => {
      Array.from(row.cells).forEach((cell, index) => {
        if (!columns.includes(index)) return;
        // Preserve original lower/upper source measurements and convert both endpoints.
        const rangeRaw = (cell.dataset.mereldonCmRange || cell.textContent.trim()).replace(',', '.');
        const rangeParts = rangeRaw.match(/^(-?\d+(?:\.\d+)?)\s*[-–]\s*(-?\d+(?:\.\d+)?)$/);
        if (rangeParts) {
          const minimum = Number(rangeParts[1]);
          const maximum = Number(rangeParts[2]);
          if (Number.isFinite(minimum) && Number.isFinite(maximum)) {
            if (!cell.dataset.mereldonCmRange) cell.dataset.mereldonCmRange = `${minimum}-${maximum}`;
            cell.textContent = unit === 'in'
              ? `${(minimum / 2.54).toFixed(1)}–${(maximum / 2.54).toFixed(1)}`
              : `${minimum}–${maximum}`;
          }
          return;
        }
        if (!cell.dataset.mereldonCm) {
          const raw = cell.textContent.trim().replace(',', '.');
          if (!/^-?\d+(\.\d+)?$/.test(raw)) return;
          cell.dataset.mereldonCm = raw;
        }
        const centimetres = Number(cell.dataset.mereldonCm);
        if (!Number.isFinite(centimetres)) return;
        cell.textContent = unit === 'in' ? (centimetres / 2.54).toFixed(1) : cell.dataset.mereldonCm;
      });
    });
  };

  // MERELDON CONDITIONAL SIZE SCROLL SHADOW — 2026-10-13
  const scrollHintSelector = '.mereldon-size-guide__table-wrap, .mereldon-size-guide__body-guide';
  const scrollHintObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver((entries) => entries.forEach(({ target }) => updateScrollHint(target)))
    : null;

  const updateScrollHint = (viewport) => {
    const shell = viewport.parentElement;
    if (!shell || !shell.classList.contains('mereldon-size-scroll-shell')) return;
    if (!viewport.clientWidth || !viewport.isConnected) {
      shell.dataset.moreRight = 'false';
      return;
    }
    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    shell.dataset.moreRight = String(maxScroll > 3 && viewport.scrollLeft < maxScroll - 3);
  };

  const setupScrollHints = () => {
    document.querySelectorAll(scrollHintSelector).forEach((viewport) => {
      if (!viewport.parentElement?.classList.contains('mereldon-size-scroll-shell')) {
        const shell = document.createElement('div');
        shell.className = 'mereldon-size-scroll-shell';
        viewport.parentNode.insertBefore(shell, viewport);
        shell.appendChild(viewport);
      }
      if (viewport.dataset.mereldonScrollHintBound !== 'true') {
        viewport.dataset.mereldonScrollHintBound = 'true';
        viewport.addEventListener('scroll', () => updateScrollHint(viewport), { passive: true });
        scrollHintObserver?.observe(viewport);
      }
      updateScrollHint(viewport);
    });
  };

  window.addEventListener('resize', setupScrollHints, { passive: true });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mereldon-size-guide-open], [data-mereldon-size-guide-tab]')) {
      window.requestAnimationFrame(setupScrollHints);
    }
  });

  const setUnit = (unit, persist = true) => {
    currentUnit = unit === 'in' ? 'in' : 'cm';
    document.querySelectorAll('[data-mereldon-unit-button]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.mereldonUnitButton === currentUnit));
    });
    document.querySelectorAll('[data-mereldon-measurements] table').forEach((table) => {
      updateTable(table, currentUnit);
    });
    if (persist) savePreference(currentUnit);
    setupScrollHints();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mereldon-unit-button]');
    if (!button) return;
    setUnit(button.dataset.mereldonUnitButton);
  });

  document.addEventListener('shopify:section:load', () => setUnit(currentUnit, false));
  currentUnit = readPreference();

  const start = () => setUnit(currentUnit, false);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.MereldonMeasurements = {
    getUnit: () => currentUnit,
    setUnit
  };
})();
